import ScrollSnap from 'scroll-snap'

ScrollSnap.start({})
